import GuidUtils from '@/shared/utils/guid'

export default class GymRatingDeadLiftModel {
  constructor({
    id,
    deadLift,
    weight,
  } = {}) {
    this.id = id || GuidUtils.emptyGuid
    this.deadLift = deadLift
    this.weight = weight
  }
}